<template>
  <div>
    <PCNavbar selectIndex="5"/>
    <MobileNavBar :currentActive="3" />
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'

export default {
  name: 'FiveNav',
  components: {
    PCNavbar,
    MobileNavBar
  },
  metaInfo: {
    title: '关于我们',
    meta: [
      { 
        vmid: 'description', 
        name: 'description', 
        content: '柳叶云是专注于医疗器械供应链管理的科技公司，致力于为医疗器械企业提供智能化、数字化的管理解决方案，实现医疗器械全程可追溯、智能补货、钉盒管理等功能。' 
      },
      { 
        vmid: 'keywords', 
        name: 'keywords', 
        content: '柳叶云,医疗器械供应链,全程可追溯,智能补货,钉盒管理,医疗器械厂商,医疗器械经销商' 
      }
    ]
  }
}
</script>
